import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BootstrapModalModule } from 'ngx-bootstrap-modal';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { DialogService } from 'ngx-bootstrap-modal';
import { CookieService } from 'ngx-cookie-service';
import { SharedModule, MessageInfoComponent, MessageInfoDetailComponent, FooterComponent, HeaderComponent, LeftComponent, DateFilter, HourFilter } from './modules/shared';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [ AppComponent ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    BootstrapModalModule,
    BrowserModule,
    SharedModule,
    BsDatepickerModule.forRoot(),
    NgbModule.forRoot(),
    RouterModule.forRoot([      
      { path: '', redirectTo: 'n5011', pathMatch: 'full' },
      //{ path: 'header', redirectTo: 'shared/header', pathMatch: 'full' },
      //{ path: 'shared', loadChildren: './modules/shared/shared.module#SharedModule', data: { preload: true } },
      { path: 'n2011', loadChildren: './modules/n201/n2011.module#N2011Module', data: { preload: false } },
      { path: 'n2012', loadChildren: './modules/n201/n2012.module#N2012Module', data: { preload: false } },
      { path: 'n2021', loadChildren: './modules/n202/n2021.module#N2021Module', data: { preload: false } },
      { path: 'n2022', loadChildren: './modules/n202/n2022.module#N2022Module', data: { preload: false } },
      { path: 'n2023', loadChildren: './modules/n202/n2023.module#N2023Module', data: { preload: false } },
      { path: 'n2031', loadChildren: './modules/n203/n2031.module#N2031Module', data: { preload: false } },
      { path: 'n2032', loadChildren: './modules/n203/n2032.module#N2032Module', data: { preload: false } },
      { path: 'n2041', loadChildren: './modules/n204/n2041.module#N2041Module', data: { preload: false } },
      { path: 'n2042', loadChildren: './modules/n204/n2042.module#N2042Module', data: { preload: false } },
      { path: 'n2043', loadChildren: './modules/n204/n2043.module#N2043Module', data: { preload: false } },
      { path: 'n2044', loadChildren: './modules/n204/n2044.module#N2044Module', data: { preload: false } },
      { path: 'n2051', loadChildren: './modules/n205/n2051.module#N2051Module', data: { preload: false } },
      { path: 'n2052', loadChildren: './modules/n205/n2052.module#N2052Module', data: { preload: false } },
      { path: 'n2061', loadChildren: './modules/n206/n2061.module#N2061Module', data: { preload: false } },
      { path: 'n2071', loadChildren: './modules/n207/n2071.module#N2071Module', data: { preload: false } },
      { path: 'n3011', loadChildren: './modules/n301/n3011.module#N3011Module', data: { preload: false } },
      { path: 'n3012', loadChildren: './modules/n301/n3012.module#N3012Module', data: { preload: false } },
      { path: 'n3021', loadChildren: './modules/n302/n3021.module#N3021Module', data: { preload: false } },
      { path: 'n3022', loadChildren: './modules/n302/n3022.module#N3022Module', data: { preload: false } },
      { path: 'n3023', loadChildren: './modules/n302/n3023.module#N3023Module', data: { preload: false } },
      { path: 'n3024', loadChildren: './modules/n302/n3024.module#N3024Module', data: { preload: false } },
      { path: 'n3025', loadChildren: './modules/n302/n3025.module#N3025Module', data: { preload: false } },
      { path: 'n3031', loadChildren: './modules/n303/n3031.module#N3031Module', data: { preload: false } },
      { path: 'n3032', loadChildren: './modules/n303/n3032.module#N3032Module', data: { preload: false } },
      { path: 'n3061', loadChildren: './modules/n306/n3061.module#N3061Module', data: { preload: false } },
      { path: 'n3062', loadChildren: './modules/n306/n3062.module#N3062Module', data: { preload: false } },
      { path: 'n3063', loadChildren: './modules/n306/n3063.module#N3063Module', data: { preload: false } },
      { path: 'n3071', loadChildren: './modules/n307/n3071.module#N3071Module', data: { preload: false } },
      { path: 'n3072', loadChildren: './modules/n307/n3072.module#N3072Module', data: { preload: false } },
      { path: 'n3073', loadChildren: './modules/n307/n3073.module#N3073Module', data: { preload: false } },
      { path: 'n4011', loadChildren: './modules/n401/n4011.module#N4011Module', data: { preload: false } },
      { path: 'n4012', loadChildren: './modules/n401/n4012.module#N4012Module', data: { preload: false } },
      { path: 'n4013', loadChildren: './modules/n401/n4013.module#N4013Module', data: { preload: false } },
      { path: 'n4021', loadChildren: './modules/n402/n4021.module#N4021Module', data: { preload: false } },
      { path: 'n4022', loadChildren: './modules/n402/n4022.module#N4022Module', data: { preload: false } },
      { path: 'n4023', loadChildren: './modules/n402/n4023.module#N4023Module', data: { preload: false } },
      { path: 'n4031', loadChildren: './modules/n403/n4031.module#N4031Module', data: { preload: false } },
      { path: 'n4032', loadChildren: './modules/n403/n4032.module#N4032Module', data: { preload: false } },
      { path: 'n4041', loadChildren: './modules/n404/n4041.module#N4041Module', data: { preload: false } },
      { path: 'n4042', loadChildren: './modules/n404/n4042.module#N4042Module', data: { preload: false } },
      { path: 'n4043', loadChildren: './modules/n404/n4043.module#N4043Module', data: { preload: false } },
      { path: 'n4051', loadChildren: './modules/n405/n4051.module#N4051Module', data: { preload: false } },
      { path: 'n4052', loadChildren: './modules/n405/n4052.module#N4052Module', data: { preload: false } },
      { path: 'n4061', loadChildren: './modules/n406/n4061.module#N4061Module', data: { preload: false } },
      { path: 'n4062', loadChildren: './modules/n406/n4062.module#N4062Module', data: { preload: false } },
      { path: 'n4071', loadChildren: './modules/n407/n4071.module#N4071Module', data: { preload: false } },
      { path: 'n4072', loadChildren: './modules/n407/n4072.module#N4072Module', data: { preload: false } },
      { path: 'n4073', loadChildren: './modules/n407/n4073.module#N4073Module', data: { preload: false } },
      { path: 'n4081', loadChildren: './modules/n408/n4081.module#N4081Module', data: { preload: false } },
      { path: 'n4091', loadChildren: './modules/n409/n4091.module#N4091Module', data: { preload: false } },
      { path: 'n4092', loadChildren: './modules/n409/n4092.module#N4092Module', data: { preload: false } },
      { path: 'n4093', loadChildren: './modules/n409/n4093.module#N4093Module', data: { preload: false } },
      { path: 'n5011', loadChildren: './modules/n501/n5011.module#N5011Module', data: { preload: true } },
      { path: 'n5012', loadChildren: './modules/n501/n5012.module#N5012Module', data: { preload: false } },
      { path: 'n5021', loadChildren: './modules/n502/n5021.module#N5021Module', data: { preload: true } },
      { path: 'n5031', loadChildren: './modules/n503/n5031.module#N5031Module', data: { preload: false } },
      { path: 'n5032', loadChildren: './modules/n503/n5032.module#N5032Module', data: { preload: false } },
      { path: 'ne01', loadChildren: './modules/ne01/ne01.module#Ne01Module', data: { preload: false } },
      { path: 'ne02', loadChildren: './modules/ne02/ne02.module#Ne02Module', data: { preload: false } },
      { path: 'ne03', loadChildren: './modules/ne03/ne03.module#Ne03Module', data: { preload: false } },
      { path: 'ne04', loadChildren: './modules/ne04/ne04.module#Ne04Module', data: { preload: false } },
      { path: 'ne05', loadChildren: './modules/ne05/ne05.module#Ne05Module', data: { preload: false } },
      { path: 'ne06', loadChildren: './modules/ne06/ne06.module#Ne05Module', data: { preload: false } },
      { path: 'ne07', loadChildren: './modules/ne07/ne07.module#Ne07Module', data: { preload: false } },
      { path: 'ne99', loadChildren: './modules/ne99/ne99.module#Ne99Module', data: { preload: false } },
      { path: '**', redirectTo: 'ne07', pathMatch: 'full'}
    ])
  ],
  providers: [    
    AppComponent,
    CookieService,
    DialogService,
    MessageInfoComponent,
    MessageInfoDetailComponent,
    FooterComponent,
    HeaderComponent,
    LeftComponent,
    DateFilter,
    HourFilter
  ],
  exports: [ RouterModule ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts